module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av460-ac6a7eaca72358602236168ad6430e9f.jpg";